import * as React from "react";
import { SVGProps } from "react";

const DeclineArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.6 20.05H19.2C19.5556 20.05 19.85 19.7556 19.85 19.4C19.85 19.0444 19.5556 18.75 19.2 18.75H5.6C5.24439 18.75 4.95 19.0444 4.95 19.4C4.95 19.7556 5.24439 20.05 5.6 20.05Z"
      fill="#DA291C"
      stroke="#DA291C"
      strokeWidth="0.1"
    />
    <path
      d="M17.5408 16.2594C17.6707 16.3892 17.8356 16.45 18.0001 16.45C18.1647 16.45 18.3296 16.3892 18.4595 16.2594C18.711 16.0078 18.711 15.5922 18.4595 15.3407L7.2595 4.14066C7.00798 3.88913 6.59232 3.88913 6.34079 4.14066C6.08927 4.39219 6.08927 4.80784 6.34079 5.05937L17.5408 16.2594Z"
      fill="#DA291C"
      stroke="#DA291C"
      strokeWidth="0.1"
    />
    <path
      d="M6.1502 12.816C6.1502 13.1716 6.44458 13.466 6.8002 13.466C7.15581 13.466 7.4502 13.1716 7.4502 12.816V5.25H15.0162C15.3718 5.25 15.6662 4.95561 15.6662 4.6C15.6662 4.24439 15.3718 3.95 15.0162 3.95H6.8002C6.44458 3.95 6.1502 4.24439 6.1502 4.6V12.816Z"
      fill="#DA291C"
      stroke="#DA291C"
      strokeWidth="0.1"
    />
  </svg>
);
export default DeclineArrow;
